import { render, staticRenderFns } from "./TestPaper.vue?vue&type=template&id=54d19e2b"
import script from "./TestPaper.vue?vue&type=script&lang=js"
export * from "./TestPaper.vue?vue&type=script&lang=js"
import style0 from "./TestPaper.vue?vue&type=style&index=0&id=54d19e2b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports